module.exports = __webpack_public_path__ + "fd72ca78cfb8b9d076b02675cd2d454c.pdf";